import React, { useState, useContext, useEffect } from 'react'
/* Mattlib */
import TextFields_Outlined from './TextFields_Outlined'
import MultipleSelect_Checkbox from './MultiSelect_Checkbox'
import Dropdown_Advanced from './Dropdown_Advanced'
import TextFields_Outlined_Phone from './TextMasks/TextMask_Phone'

/* Button */
import Button from '@material-ui/core/Button';
import { createTheme, ThemeProvider  } from "@material-ui/core";

/* Fade in */
import FadeIn from './FadeIn'
/* Data JSON */
import grades from '../data/grades.json'

import ColumnStatus from './ColumnStatus'

import Modal_Bootstrap from './Modal_Bootstrap'

/* Bottom Nav */


/* Context */
import ContentContext from './ContentContext'

/* Bootstrap */
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import 'bootstrap/dist/css/bootstrap.min.css';
import MultipleSelect from './MultiSelect_Checkbox';

// Context
import { useTranslation, useTranslationUpdate} from './TranslationContexts/TranslationDataContext'
import Checkbox_Regular from './Checkbox_Regular';
import { NightsStay } from '@material-ui/icons'

const Interpretation_Testing = ({ handleContinueButton, handleProgressBarChange }) => {
  const { contentState, setContentState } = useContext(ContentContext)
  //const { dataContext, setDataContext } = useContext(TranslationDataContext)

  const dataForQB = useTranslation()
  console.log("-----------------")
  console.log(dataForQB)
  console.log("-----------------")
  const setDataForQB = useTranslationUpdate()

  const useStyles = createTheme((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

  //const classes = useStyles();

  //////////////////////////////////////////////////////////////
  // COLUMN VALIDATION - UI TO SHOW THIS
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 1
  //////////////////////////////////////////////////////////////
  const [translationTypes, setTranslationTypes] = useState(''); // new one for multi-select
  const handleTranslationTypeChanges = (selectedTypes) => {
    setTranslationTypes(selectedTypes);
  }
  const [isOnlineOrVitrualMeeting, setIsOnlineOrVirtualMeeting] = useState(false)
  const [col1RequiredFields, setCol1RequiredFields] = useState({
    dueDate_int: '',
    interpretationTypes_int: '',
    estimatedDurationHrs_int: '',
    estimatedDurationMins_int: ''
  })
  const [column1Complete, setColumn1Complete] = useState(false)
  //////////////////////////////////////////////////////////////

  //////////////////////////////////////////////////////////////
  // Column 2
  //////////////////////////////////////////////////////////////
  // States
  const [currentDistrict, setCurrentDistrict] = useState("")
  const [column2Complete, setColumn2Complete] = useState(false)
  const [renderOtherLang, setRenderOtherLang] = useState(false)

  const updateNonRequireField = (id, valueInInput) =>{
    dataForQB[id] = valueInInput
  }


  //////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////

  const handleThisContinueButton = function (newState) {
    handleContinueButton(newState)
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      //setProgressBarDataInParent();
      //console.log(column1Complete, column2Complete);
    }, 100);
    return () => clearTimeout(timer);
  }, [column1Complete, column2Complete]);

  const [showInitPrompt, setShowInitPrompt] = useState(true)
  const [numOfRows, setNumOfRows] = useState(10)
  const setTableData_nameOfStudent = (idx, e) => {
    tableData[idx].nameOfStudent = e.target.value;
    dataForQB.tableData_int = tableData;
    console.log(dataForQB)
  }
  const setTableData_grade = (idx, e) => {
    tableData[idx].grade = e.target.value;
    dataForQB.tableData_int = tableData;
    console.log(dataForQB)
  }
  const setTableData_iep = (idx, e) => {
    tableData[idx].iep = e.target.value;
    dataForQB.tableData_int = tableData;
    console.log(dataForQB)
  }
  const [tableData, setTableData] = useState([
      {
        index: 0,
        lineNum: 1,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 1,
        lineNum: 2,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 2,
        lineNum: 3,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 3,
        lineNum: 4,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 4,
        lineNum: 5,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 5,
        lineNum: 6,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 6,
        lineNum: 7,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 7,
        lineNum: 8,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 8,
        lineNum: 9,
        nameOfStudent: '',
        grade: '',
        iep: ''
      },
      {
        index: 9,
        lineNum: 10,
        nameOfStudent: '',
        grade: '',
        iep: ''
      }
    ])
  function runAllValidations (){
    let passed = true;
    
    dataForQB.students = tableData;
    console.log("data for qb")
    console.log(dataForQB.students)
    console.log("table data")
    console.log(tableData)

    if (passed){
      handleThisContinueButton("approval-interp")
    }
  }
  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }
  function validatePhone(phone)
  {
    var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    if(phone.match(phoneno)) return true;
    else return false;
  }

  // UP TO THIS HERE
  function addAnotherRow(){
    if (numOfRows>39){
      alert("You've reached the maxmimum amount of rows")
      return;
    }
    var temp = tableData;
    temp.push({
      index: numOfRows,
      lineNum: numOfRows+1,
      nameOfStudent: '',
      grade: 0,
      iep: ''
    })
    setNumOfRows(numOfRows+1)
    setTableData(temp)
  }
  //////////////////////////////////////////////////////////////

  return (
    <ThemeProvider theme={useStyles}>
    <div>{/* className={classes.root}>*/}
      <FadeIn delay={200} duration={450}>
      <div>
        <p style={{textAlign: 'center'}}><b>Students</b></p>
        <table id='interpretation-testing-table'>
          <thead>
            <th className="interpretation-testing-col0">Line Num</th>
            <th className="interpretation-testing-col1">Name of Student(s)</th>
            <th className="interpretation-testing-col2">Grade</th>
            <th className="interpretation-testing-col3">IEP/504 Accomodations</th>
          </thead>
          <tbody>
            {tableData.map(({index, lineNum, nameOfStudent, grade, iep}) => (
              <tr>
                <td id={index==tableData.length-1 ? `interpretation-testing-jump-to` : ``} className={`interpretation-testing-col0`}>
                  <b>{`${lineNum}.`}</b>
                </td>
                <td className={`interpretation-testing-col1`}>
                  <input type='text' id={`student${index}`} onKeyUp={(e) => setTableData_nameOfStudent(index, e)}/>
                </td>
                <td className={`interpretation-testing-col2`}>
                  <select type='text' id={`grade${index}`} onChange={(e) => setTableData_grade(index, e)}>
                    <option></option><option>Pre-K</option><option>K</option><option>1</option>
                    <option>2</option><option>3</option><option>4</option><option>5</option>
                    <option>6</option><option>7</option><option>8</option><option>9</option>
                    <option>10</option><option>11</option><option>12</option>
                  </select>
                </td>
                <td className={`interpretation-testing-col3`}>
                  <input type='text' id={`iep${index}`} onKeyUp={(e) => setTableData_iep(index, e)}/>
                </td>
              </tr>
            ))
          } 
          <tr><td colSpan={4}><a href='#interpretation-testing-jump-to' onClick={() => addAnotherRow()}>Add Another Line</a></td></tr>
          </tbody>
        </table>

        </div>
        <br/>
        <div className="form-button-bottom-container" id="iinterpretation-testing-jump-to">
          <Button className="btn btn-primary form-button-bottom" onClick={() => runAllValidations()} disabled={false}//!column1Complete || !column2Complete || !column3Complete}
            variant="contained" color="primary">
            Next Page
          </Button>
        </div>

        {/* Init Prompt */}
        <div>
          <Modal_Bootstrap openModal={showInitPrompt} 
            setOpenModalStateInParent={setShowInitPrompt} 
            modalTitle="Instructions" 
            modalContents="If this Interpretation is for Testing, please enter each student. If not, please leave it blank."/>
        </div>

      </FadeIn>
    </div>
    </ThemeProvider>
  )
}

export default Interpretation_Testing
